AngularService = App.loadClass 'core::Angular/Service'

class exports.OnFarmStorageService extends AngularService
    constructor: (@http, $resource, $state) ->
        app = $state.current.name.split('.')[0]
        @StorageLocation = $resource "backend/#{app}/storage-locations/:id",
            id: '@id'
        ,
            update: method: 'PUT'

        @StorageFan = $resource "backend/#{app}/storage-locations/:binId/fans/:id",
            binId: '@storage_locations_id'
            id: '@id'
        ,
            update: method: 'PUT'

        @BinInspection = $resource "backend/#{app}/storage-locations/:binId/inspections/:id",
            binId: '@storage_locations_id'
            id: '@id'
        ,
            update: method: 'PUT'

        @Measurement = $resource 'backend/portal/storage-measurements/:id',
            id: '@id'
        ,
            update: method: 'PUT'

    getYears: () ->
        return @http.get 'backend/portal/on-farm-storage/contract-years'
        .then (response) ->
            return response.data

    getUsers: (year) ->
        return @http.get 'backend/portal/on-farm-storage/users-by-year',
            params: { year }
        .then (response) ->
            return response.data

    getContracts: (year, user) ->
        return @http.get 'backend/portal/on-farm-storage/contracts-by-year',
            params:
                year: year
                userId: user.id
        .then (response) ->
            return response.data

    getBins: (user) ->
        return @StorageLocation.query
            userId: user.id
        .$promise.then (bins) ->
            return bins.filter (bin) ->
                return bin.type is 'Bin' or bin.type is 'Silo'

    getBinId: (year, binId) ->
        return @http.get 'backend/portal/on-farm-storage/bin-id',
            params:
                year: year
                binId: binId
        .then (response) ->
            return response.data

    saveBinId: (year, bin) ->
        return @http.post 'backend/portal/on-farm-storage/save-bin-id',
            year: year
            id: bin.id
            binId: bin.bin_id

    getMeasurementId: (contract, bin) ->
        return @http.get 'backend/portal/on-farm-storage/measurement-id',
            params:
                contractId: contract.id
                binId: bin.id
        .then (response) ->
            return response.data
